import { graphql } from "../gql";

export const createClaimAuditGroupMutationDoc = graphql(`
  mutation createClaimAuditGroup($input: CreateClaimAuditGroupInput!) {
    createClaimAuditGroup(input: $input) {
      claimAuditGroup {
        appealDueDate
        auditStartDate
        createdAt
        disputeDueDate
        finalProviderReportSentDate
        id
        name
        qaDueDate
        totalClaimsCount
      }
    }
  }
`);
